export default "__VITE_ASSET__DFbpUSrH__"